import * as React from 'react'
import { TreatmentTrackOptions } from 'consts/giConsts'

const FillByTrackStatus = {
  [TreatmentTrackOptions.OnTrack]: '#26C36F',
  [TreatmentTrackOptions.OffTrack]: '#EB5757'
}

/** No tracking decision: the plain dark dot the rest of the timeline uses, at this axis's size. */
const NO_TRACK_STATUS_FILL = '#001335'

/**
 * A scan on the time-based timeline, drawn by its tracking status.
 *
 * The marker carries the aligner the scan was taken on, which is the thing a doctor reads down the
 * column. A scan with no aligner number falls back to a mark for the tracking decision itself - a
 * check on track, an exclamation off it - so the marker is never blank.
 *
 * The 15px marker carries a 2px ring in the panel colour, which is what keeps two markers legible
 * where the axis brings them close enough to overlap. The stroke sits outside the fill, so the dot
 * reads at its full size rather than at the size the ring leaves it.
 *
 * Deliberately not the shared NormalGrinScanItem even in the untracked case: that 8px dot is what
 * the other three variations draw, and it must stay that size for them.
 */
export default ({ trackStatus, alignerNumber }) => {
  const fill = FillByTrackStatus[trackStatus] || NO_TRACK_STATUS_FILL
  const label = alignerNumber == null || alignerNumber === '' ? null : String(alignerNumber)

  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="9.5" cy="9.5" r="8.5" fill={fill} stroke="var(--bg-color-timelineV2)" strokeWidth="2" />
      {label ? (
        <text
          x="9.5"
          y="9.5"
          textAnchor="middle"
          dominantBaseline="central"
          fill="white"
          fontFamily="Dazzed, sans-serif"
          // Three figures only just fit inside the dot, so they are set smaller rather than clipped.
          fontSize={label.length > 2 ? 6 : 8}
          fontWeight="600"
        >
          {label}
        </text>
      ) : (
        <>
          {trackStatus === TreatmentTrackOptions.OnTrack && (
            <path d="M6 9.7L8.4 12.1L13.4 6.9" stroke="white" strokeWidth="2" strokeLinecap="round" />
          )}
          {trackStatus === TreatmentTrackOptions.OffTrack && (
            // Butt caps, not round: a round cap grows a stroke by half its width at each end, which
            // closes the gap between the bar and its dot and leaves one solid stroke.
            <>
              <path d="M9.5 5.5V10.5" stroke="white" strokeWidth="2" />
              <path d="M9.5 12V13.5" stroke="white" strokeWidth="2" />
            </>
          )}
        </>
      )}
    </svg>
  )
}
